import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgPort = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="M13 7.83a3.001 3.001 0 1 0-2 0V9H9a1 1 0 0 0 0 2h2v8.954c-1.62-.15-3.03-.663-4.07-1.417-1.042-.757-1.702-1.745-1.881-2.894l.504.251a1 1 0 1 0 .894-1.788l-2-1A1 1 0 0 0 3 14v1c0 2.165 1.092 3.947 2.756 5.155C7.404 21.352 9.62 22 12 22s4.596-.648 6.244-1.845C19.908 18.947 21 17.165 21 15v-1a1 1 0 0 0-1.447-.894l-2 1a1 1 0 1 0 .894 1.788l.504-.251c-.179 1.149-.84 2.137-1.882 2.894-1.038.754-2.45 1.267-4.069 1.417V11h2a1 1 0 1 0 0-2h-2V7.83ZM11 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z" />
  )
export default SvgPort
